import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const FAQ_DE = [
  {
    q: "Welche Größe Torwarthandschuhe brauche ich?",
    a: "Miss den Umfang deiner dominanten Hand (ohne Daumen) in Zentimetern. Größe 6 = 17–18 cm (Kinder/Jugend), Größe 8 = 20–21 cm (Junior/Damen), Größe 9 = 22–23 cm (Standard Herren), Größe 10 = 23–24 cm. Im Zweifel die kleinere Größe wählen — Latex dehnt sich beim Tragen leicht aus.",
  },
  {
    q: "Was ist German Giga Grip Latex?",
    a: "German Giga Grip ist ein in Deutschland produziertes Premium-Latex mit extremer Haftung bei Nässe und Feuchtigkeit. Ein weicher, klebriger Compound für maximalen Grip – ideal für Torhüter, die in jedem Wetter das Maximum wollen. Die Mamba Edition von 4keeperz nutzt 4 mm German Giga Grip.",
  },
  {
    q: "Was bedeutet Negative Cut?",
    a: "Negative Cut ist eine Schnittform, bei der die Latex-Innenfläche kleiner als die Außenfläche zugeschnitten ist. Das ergibt eine engere, hautnahe Passform und mehr direktes Ballgefühl — beliebt bei modernen Profitorhütern.",
  },
  {
    q: "Wie pflege ich meine Latex-Torwarthandschuhe richtig?",
    a: "Vor dem ersten Tragen leicht anfeuchten. Nach jedem Spiel mit lauwarmem Wasser ohne Seife auswaschen, niemals in der Waschmaschine. Lufttrocknen liegend, nie in direkter Sonne oder auf der Heizung — UV-Licht und Hitze zerstören Latex. Nicht zusammen mit anderen Sachen lagern, damit die Innenflächen nicht verkleben.",
  },
  {
    q: "Was ist Breathapren und warum ist es besser als Neopren?",
    a: "Breathapren ist ein atmungsaktives Hightech-Material für den Handschuh-Body. Im Vergleich zu Standard-Neopren leitet es Schweiß besser ab, hält die Hand kühler und bleibt bei Hitze formstabil. Das verlängert auch die Lebensdauer des Latex, weil der Handschuh innen trockener bleibt.",
  },
  {
    q: "Liefert 4keeperz in die Schweiz und nach Liechtenstein?",
    a: "Ja. Wir versenden mit der Schweizerischen Post in die ganze Schweiz und nach Liechtenstein. Versandkosten: CHF 8 pauschal, ab CHF 80 Bestellwert gratis. Lieferung in 2–4 Werktagen.",
  },
  {
    q: "Sind 4keeperz Torwarthandschuhe für Profis geeignet?",
    a: "Ja. Wir verwenden dieselben Materialklassen wie viele Premium-Marken (German Giga Grip & Contact Grip Latex aus Deutschland, Breathapren-Body, Silikon-Punchingzone, Dual Stripe Verschluss). Der einzige Unterschied: faire Preise. Gegründet von Segsan Gröschel, aktiver Torwart beim FC Wädenswil — in Zusammenarbeit mit Ex-Fussballprofi Ivan Bonfardin (u.a. FC Zürich, Juventus Turin).",
  },
  {
    q: "Bietet ihr Vereinsrabatte für Schweizer Fußballvereine an?",
    a: "Ja, wir haben Sonderkonditionen für Vereine und Mannschaften. Schreib uns an info@4keeperz.ch mit deinem Verein und der gewünschten Stückzahl — wir machen dir ein individuelles Angebot.",
  },
  {
    q: "Gibt es 4keeperz Torwarthandschuhe auch für Damen und Junior-Keeper?",
    a: "Ja. Unsere Torwarthandschuhe gibt es in den Größen 6 bis 10 — geeignet für Kinder, Jugendliche, Damen und Herren. Größe 6–7 passt typischerweise für Junior- und Damen-Keeper, ab Größe 8 für Erwachsene. Beide Editionen (Mamba & Panther) sind unisex geschnitten.",
  },
  {
    q: "Wo kann ich 4keeperz Torwarthandschuhe online kaufen?",
    a: "Direkt hier auf 4keeperz.ch. Wir verkaufen ausschließlich online über unseren eigenen Shop, nicht über Drittplattformen. Bezahlung per Kreditkarte (Visa, Mastercard, American Express). Versand mit Schweizerischer Post in die Schweiz und nach Liechtenstein, ab CHF 80 Bestellwert gratis.",
  },
  {
    q: "Wie unterscheiden sich Mamba und Panther Edition?",
    a: "Mamba Edition (CHF 99) nutzt 4mm German Giga Grip Latex — maximale Klebrigkeit, ideal für nasse Bedingungen. Panther Edition (CHF 109) nutzt 4mm German Contact Grip Latex — ausbalancierter Allrounder, robuster, perfekt für trockene Bedingungen. Beide haben Breathapren Body, Negative Cut und Dual Stripe Verschluss. Punchingzone: Mamba mit Silikon, Panther mit New German Basic Latex.",
  },
  {
    q: "Was ist der Vorteil des Dual Stripe Verschluss?",
    a: "Der Dual Stripe Verschluss besteht aus zwei schmalen Klettverschlüssen anstelle eines breiten Bandes. Der grosse Vorteil: Die Latex-Fangfläche läuft ungehindert bis zum Handgelenk durch – anders als bei Marken, wo ein breiter Strap die Greif-Fläche verdeckt. Du hast mehr aktive Grip-Zone, während das Handgelenk trotzdem sicher fixiert bleibt.",
  },
  {
    q: "Gibt es Bundle-Rabatte bei 4keeperz?",
    a: "Ja. Wenn du einen Torwarthandschuh (Mamba oder Panther) zusammen mit unserer Cordura Glove Bag kaufst, bekommst du automatisch CHF 5 Rabatt. Der Rabatt wird direkt im Warenkorb abgezogen.",
  },
];

const FAQ_EN = [
  {
    q: "What size goalkeeper gloves do I need?",
    a: "Measure the circumference of your dominant hand (without thumb) in centimetres. Size 6 = 17–18 cm (kids), size 8 = 20–21 cm (junior/women), size 9 = 22–23 cm (standard men), size 10 = 23–24 cm. When in doubt, go one size smaller — latex stretches slightly with use.",
  },
  {
    q: "What is German Giga Grip latex?",
    a: "German Giga Grip is a German-made premium latex with extreme grip in wet conditions. A soft, sticky compound for maximum grip — the first choice for goalkeepers who want the most out of every weather condition. Our Mamba Edition uses 4 mm German Giga Grip.",
  },
  {
    q: "What does Negative Cut mean?",
    a: "Negative Cut means the inner palm latex is cut slightly smaller than the outer shell, giving a tighter fit and more direct ball feel — a favourite among modern professional goalkeepers.",
  },
  {
    q: "How do I care for latex goalkeeper gloves?",
    a: "Lightly moisten before first use. After each match wash with lukewarm water and no soap — never in a washing machine. Air dry flat, away from direct sunlight and radiators (UV and heat destroy latex). Store separately so palms don't stick together.",
  },
  {
    q: "What is Breathapren and why is it better than neoprene?",
    a: "Breathapren is a breathable hi-tech material for the glove body. Compared to standard neoprene it wicks sweat better, keeps hands cooler and stays dimensionally stable in heat — which also extends latex lifespan because the glove stays drier inside.",
  },
  {
    q: "Does 4keeperz ship to Switzerland and Liechtenstein?",
    a: "Yes. We ship via Swiss Post to all of Switzerland and Liechtenstein. Shipping is CHF 8 flat, free above CHF 80. Delivery in 2–4 business days.",
  },
  {
    q: "Are 4keeperz gloves suitable for professional goalkeepers?",
    a: "Yes. We use the same material classes as many premium brands (German Giga Grip & Contact Grip latex from Germany, Breathapren body, silicone punch zone, dual stripe closure). The only difference is fair pricing. Founded by Segsan Gröschel, active goalkeeper at FC Wädenswil — in collaboration with ex-pro Ivan Bonfardin (FC Zürich, Juventus Turin, etc.).",
  },
  {
    q: "Do you offer club discounts for Swiss football clubs?",
    a: "Yes — we have special conditions for clubs and teams. Email info@4keeperz.ch with your club and required quantity and we'll make you a custom offer.",
  },
  {
    q: "Are 4keeperz goalkeeper gloves available for women and junior keepers?",
    a: "Yes. Our goalkeeper gloves come in sizes 6 through 10 — suitable for kids, juniors, women and men. Sizes 6–7 typically fit junior and women keepers, size 8+ for adults. Both editions (Mamba & Panther) are unisex cut.",
  },
  {
    q: "Where can I buy 4keeperz goalkeeper gloves online?",
    a: "Directly here on 4keeperz.ch. We sell exclusively through our own online shop, not via third-party marketplaces. Payment by credit card (Visa, Mastercard, American Express). Shipping via Swiss Post to Switzerland and Liechtenstein, free above CHF 80.",
  },
  {
    q: "How do Mamba and Panther Edition differ?",
    a: "Mamba Edition (CHF 99) uses 4mm German Giga Grip latex — maximum tackiness, ideal for wet conditions. Panther Edition (CHF 109) uses 4mm German Contact Grip latex — balanced all-rounder, more durable, perfect for dry conditions. Both feature Breathapren body, negative cut and dual stripe closure. Punch zone: Mamba uses silicone, Panther uses New German Basic Latex.",
  },
  {
    q: "What's the advantage of the Dual Stripe closure?",
    a: "The Dual Stripe closure uses two narrow velcro straps instead of one wide band. The key advantage: the latex catching surface runs uninterrupted all the way to the wrist — unlike brands where a wide strap covers the grip area. You get more active grip zone while the wrist stays securely locked.",
  },
  {
    q: "Are there bundle discounts at 4keeperz?",
    a: "Yes. If you buy a goalkeeper glove (Mamba or Panther) together with our Cordura Glove Bag, you automatically get a CHF 5 discount. The bundle discount is applied instantly in the cart.",
  },
];

const FAQSection = () => {
  const { lang } = useLanguage();
  const items = lang === "de" ? FAQ_DE : FAQ_EN;
  const [openIdx, setOpenIdx] = useState(0);

  // Inject FAQPage JSON-LD (Schema.org) so Google can show expandable FAQ
  // rich results directly below the search result → +CTR.
  useEffect(() => {
    const scriptId = "homepage-faq-schema";
    document.getElementById(scriptId)?.remove();
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = scriptId;
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      inLanguage: lang === "de" ? "de-CH" : "en",
      mainEntity: items.map((it) => ({
        "@type": "Question",
        name: it.q,
        acceptedAnswer: { "@type": "Answer", text: it.a },
      })),
    });
    document.head.appendChild(script);
    return () => document.getElementById(scriptId)?.remove();
  }, [items, lang]);

  const heading = lang === "de" ? "Häufige Fragen" : "FAQ";
  const kicker = lang === "de" ? "Wissen für Keeper" : "Goalkeeper knowledge";
  const subline =
    lang === "de"
      ? "Alles, was du über Torwarthandschuhe, Material, Pflege und Versand wissen musst."
      : "Everything you need to know about goalkeeper gloves, material, care and shipping.";

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-32 mx-auto max-w-[1400px] px-6 md:px-12"
    >
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-4">
          <div className="font-condensed uppercase tracking-[0.3em] text-xs text-[#00A651] mb-3">
            {kicker}
          </div>
          <h2 className="font-brush text-5xl md:text-7xl leading-none mb-6 text-white">
            {heading}
          </h2>
          <p className="text-white/60 leading-relaxed text-base max-w-md">{subline}</p>
        </div>

        <div className="lg:col-span-8" data-testid="faq-list">
          <div className="border-t border-white/10">
            {items.map((it, i) => {
              const open = openIdx === i;
              return (
                <article
                  key={i}
                  className="border-b border-white/10"
                  data-testid={`faq-item-${i}`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    className="w-full text-left py-5 md:py-6 flex items-center gap-6 group"
                    aria-expanded={open}
                    data-testid={`faq-question-${i}`}
                  >
                    <span className="font-mono text-[11px] text-[#00A651]/70 tabular-nums w-8 shrink-0">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="flex-1 font-condensed uppercase tracking-wider text-base md:text-lg text-white group-hover:text-[#00A651] transition-colors">
                      {it.q}
                    </span>
                    <ChevronDown
                      className={`w-4 h-4 text-white/40 shrink-0 transition-transform duration-300 ${
                        open ? "rotate-180 text-[#00A651]" : ""
                      }`}
                    />
                  </button>
                  <div
                    className={`grid transition-all duration-300 ease-out ${
                      open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p
                        className="pb-6 pl-14 pr-6 text-white/70 leading-relaxed text-sm md:text-base"
                        data-testid={`faq-answer-${i}`}
                      >
                        {it.a}
                      </p>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
